var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsEnum, IsNumber, IsOptional, IsString, ValidateNested, } from 'class-validator';
import { AppointmentStatus } from '../../appointments/enums/appointment-status.enum.js';
import { AttendanceOutcome } from '../../appointments/enums/attendance-outcome.enum.js';
import { CancellationOrigin } from '../../appointments/enums/cancellation-origin.enum.js';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { AppointmentTaskViewDto } from './appointment-task-view.dto.js';
import { TreatmentProgressDto } from './treatment-progress.dto.js';
export class MyDayParticipantDto {
    patientId;
    firstName;
    lastName;
    /** Their Terminstatus (TM-9737): `null` until recorded, and on a series occurrence. */
    attendance;
    /** Who cancelled their participation, read with `attendance`. */
    cancellationOrigin;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], MyDayParticipantDto.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayParticipantDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayParticipantDto.prototype, "lastName", void 0);
__decorate([
    IsEnum(AttendanceOutcome),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayParticipantDto.prototype, "attendance", void 0);
__decorate([
    IsEnum(CancellationOrigin),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayParticipantDto.prototype, "cancellationOrigin", void 0);
/**
 * One appointment of the caller's day, with what it still needs — the row of the
 * top-bar day list. Upcoming appointments come with no tasks; a series occurrence
 * not materialized yet carries the calendar's synthetic `virtual:` id and no tasks
 * either, until it is opened.
 */
export class MyDayAppointmentDto {
    id;
    scheduledStart;
    plannedDuration;
    status;
    treatmentLocation;
    /** Named by the caller's office location's rooms on the client. */
    roomId;
    /** The stored Titel: the Heilmittel code(s), or "Beratung – {PatientName}". */
    service;
    participants;
    treatmentProgress;
    /**
     * The plan the appointment belongs to — the target of the row's plan link. Null
     * without a plan, and when the units come from more than one: the link then has
     * no single target.
     */
    treatmentPlanId;
    tasks;
}
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], MyDayAppointmentDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Type(() => Date),
    Expose(),
    __metadata("design:type", Date)
], MyDayAppointmentDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], MyDayAppointmentDto.prototype, "plannedDuration", void 0);
__decorate([
    IsEnum(AppointmentStatus),
    Expose(),
    __metadata("design:type", String)
], MyDayAppointmentDto.prototype, "status", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    Expose(),
    __metadata("design:type", String)
], MyDayAppointmentDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayAppointmentDto.prototype, "roomId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayAppointmentDto.prototype, "service", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => MyDayParticipantDto),
    Expose(),
    __metadata("design:type", Array)
], MyDayAppointmentDto.prototype, "participants", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => TreatmentProgressDto),
    Expose(),
    __metadata("design:type", Object)
], MyDayAppointmentDto.prototype, "treatmentProgress", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], MyDayAppointmentDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AppointmentTaskViewDto),
    Expose(),
    __metadata("design:type", Array)
], MyDayAppointmentDto.prototype, "tasks", void 0);
//# sourceMappingURL=my-day-appointment.dto.js.map